import { Bag } from "@repo/apis/bag";
import { BagSdkMethod } from "../utils/method-initialiser";

type Messages = NonNullable<
  NonNullable<Bag["delivery"]["options"]>[number]
>["messages"];

type QualificationPrompt = {
  bagUpgradeQualified: Messages["bagAutoUpgradeQualified"];
  bagUpgradePrompt: Messages["bagAutoUpgradePrompt"];
} | null;

type PublicGetFreeDeliveryQualificationMethod = () => QualificationPrompt;
type GetFreeDeliveryQualificationMethod =
  BagSdkMethod<PublicGetFreeDeliveryQualificationMethod>;

const stripHtmlFromMessage = (
  msg?: Messages["bagAutoUpgradePrompt"],
): Messages["bagAutoUpgradePrompt"] | undefined => {
  if (!msg) return undefined;

  const hasHtml = /<[^>]+>/.test(msg.message);
  if (!hasHtml) return msg;

  const message = msg.message
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<[^>]+>/g, "");

  return {
    ...msg,
    message,
  };
};

export const getFreeDeliveryQualificationInitialiser: GetFreeDeliveryQualificationMethod =

    ({ state }) =>
    () => {
      const bag = state.getBag();

      if (!bag || !bag.delivery?.options) {
        return null;
      }

      const qualifiedOption = bag.delivery.options.find(
        (deliveryOption) =>
          !!deliveryOption.messages?.bagAutoUpgradePrompt ||
          !!deliveryOption.messages?.bagAutoUpgradeQualified,
      );

      if (!qualifiedOption) {
        return null;
      }

      const {
        messages: { bagAutoUpgradeQualified, bagAutoUpgradePrompt } = {},
      } = qualifiedOption;

      return {
        bagUpgradeQualified: stripHtmlFromMessage(bagAutoUpgradeQualified),
        bagUpgradePrompt: stripHtmlFromMessage(bagAutoUpgradePrompt),
      };
    };
